// extracted by mini-css-extract-plugin
export default {"root":"Poster_root__wB6o9","hidden":"Poster_hidden__yjZlz"};